import React from "react";
import Hero from "../Components/core/HomePage/hero";
import Programs from "../Components/core/HomePage/programs";
import Features from "../Components/core/HomePage/features";
import Mentors from "../Components/core/HomePage/mentors";
import Testimonials from "../Components/core/HomePage/testimonial";
import IITJam from "../Components/core/HomePage/iit-jam";

const Home = () => {
  return (
    <div>
      <Hero />
      <Programs />
      <Features />
      <IITJam />
      <Mentors />
      <Testimonials />
    </div>
  );
};

export default Home;
